import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { TitleBar } from 'styles/layout/titlebar';
import { Content } from 'styles/globalStyles';
import WPSDataTable from 'components/wpstaq/WPSDataTable/WPSDataTable';
import { partnersSelector } from 'store/user/userSelectors';
import JsxHelper from 'helpers/jsx';
import ReportsService from 'services/report';
import ArrayHelper from 'helpers/array';
import DialogHelper from 'helpers/dialog';
import PlanHelper from 'helpers/plan';
import useModal from 'hooks/useModal';
import { getErrorMsg } from 'helpers';
import DateHelper from 'helpers/date';

const ClientSubscriptions = () => {
  const BREADCRUMBS = JsxHelper.createBreadcrumbs('Client Subscriptions', 'reports');
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const allPartners = useSelector(partnersSelector);
  const modalDialog = useModal();
  const [selectedPartner, setSelectedPartner] = useState("");
  const [monthsAgo, setMonthsAgo] = useState(3);

  const handleSelectPartner = e => {
    const { value } = e.target;
    setSelectedPartner(!value ? null : value);
    refreshReport(value);
  };

  const handleSelectMonthsAgo = e => {
    const { value } = e.target;
    setMonthsAgo(value);
    if (selectedPartner) {
      refreshReport(selectedPartner);
    }
  };

  const refreshReport = async (partnerSlug) => {
    if (!partnerSlug) {
      return;
    }
    setLoading(true);
    const data = { partner_slug: partnerSlug, months_ago: monthsAgo };
    ReportsService.lisClientSubscriptions(data)
      .then((response) => setTableData(response))
      .catch((err) => DialogHelper.error(modalDialog, getErrorMsg(err)))
      .finally(() => setLoading(false));
  };

  // ----------------------------------
  // TABLE
  // ----------------------------------

  const headers = [
    JsxHelper.createTableTimeHeader('created_at', null, '15%', 'Create Time'),
    JsxHelper.createTableTitleHeader('name', 'Subscription', '30%', 'plan_name'),
    JsxHelper.createTableStatusHeader('status', PlanHelper.getSubscriptionStatusColor, false),
    JsxHelper.createTablePeriodHeader('starts_at', 'ends_at', 'Period', '20%'),
    JsxHelper.createTableTitleHeader('subscriber_display_name', 'Subscriber', '25%', 'subscriber_email'),
    JsxHelper.createTableActionsHeader([], '0%'),
  ];

  return (
    <Fragment>
      <TitleBar>
        <TitleBar.Title breadcrumbs={BREADCRUMBS}>Client Subscriptions</TitleBar.Title>
        <TitleBar.Actions>
          {JsxHelper.createSelectInput({
            name: 'partner_slug_option',
            value: selectedPartner,
            options: ArrayHelper.buildSelectOptions(allPartners, 'display_name', 'slug'),
            isSearchable: true,
            onChange: handleSelectPartner,
            placeholder: 'Select partner...',
            sortOff: true
          })}
          {JsxHelper.createSelectInput({
            name: 'months_ago_option',
            value: monthsAgo,
            options: DateHelper.getMonthsSelectOptions(),
            isSearchable: true,
            onChange: handleSelectMonthsAgo,
            sortOff: true
          })}
          {JsxHelper.createBackButton('/reports')}
        </TitleBar.Actions>
      </TitleBar>
      <Content>
        {selectedPartner && <WPSDataTable loading={loading} columns={headers} body={tableData} />}
        {!selectedPartner && (
          <div class='select-data-required'>
            <h4>Select a partner to view their subscriptions</h4>
          </div>
        )}
      </Content>
    </Fragment>
  );
};

export default ClientSubscriptions;
